import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { FinancialEntityNamesParams } from './service';

export enum FinancialEntityNamesActions {
  Failure = '[Catalogs FinancialEntityNames] Failure',
  Request = '[Catalogs FinancialEntityNames] Request',
  Success = '[Catalogs FinancialEntityNames] Success',
  Reset = '[Catalogs FinancialEntityNames] Reset',
}

export const FinancialEntityNamesFailure = createAction(
  FinancialEntityNamesActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const FinancialEntityNamesRequest = createAction(
  FinancialEntityNamesActions.Request,
  props<{ parameters: FinancialEntityNamesParams }>()
);

export const FinancialEntityNamesSuccess = createAction(
  FinancialEntityNamesActions.Success,
  props<{ data: ParameterResult[] }>()
);

export const FinancialEntityNamesReset = createAction(FinancialEntityNamesActions.Reset);
